<template>
  <div>
    <v-card width="400" class="mx-auto mt-5">
      <v-card-title class="pb-0">
        <span class="display-1">Login</span>
      </v-card-title>
      <v-card-text>
        <v-form>
          <v-text-field
            label="Username"
            prepend-icon="mdi-account-circle"
            v-model="user.username"
            autocomplete="off"
            :readonly="winAuth"
          />
          <v-text-field
            :type="showPassword ? 'text' : 'password'"
            label="Password"
            prepend-icon="mdi-lock"
            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
            @click:append="showPassword = !showPassword"
            v-model="user.password"
            @keyup.enter="authenticate"
            autocomplete="off"
          />

          <v-select
            label="Client"
            prepend-icon="mdi-database"
            v-model="user.dbName"
            :loading="isDatabaseLoading"
            :items="databases"
            item-text="companyName"
            item-value="companyCode"
            autocomplete="off"
          ></v-select>
          <div class="text-xs-right">
            <a @click.stop="forgotPassword">
              <span class="body-1 text-none">Forgot Password?</span>
            </a>
          </div>
          <!-- <v-checkbox v-model="winAuth" label="Windows Authentication"></v-checkbox> -->
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn color="success">Register</v-btn> -->
        <v-btn color="info" @click.stop="authenticate" :loading="loading"
          >Login</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-dialog v-model="forgotDialog" width="700" persistent>
      <v-card>
        <v-card-title>
          <span class="headline">Forgot Password</span>
        </v-card-title>
        <v-card-text>
          <v-stepper v-model="e1">
            <v-stepper-header>
              <v-stepper-step :complete="e1 > 1" step="1"
                >Provide your Username</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step :complete="e1 > 2" step="2"
                >Verification Code</v-stepper-step
              >

              <v-divider></v-divider>

              <v-stepper-step step="3">New password</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <!-- <v-card class="mb-5" color="grey lighten-1" height="200px"></v-card> -->
                <v-text-field
                  label="Username"
                  v-model="forgotPasswordModel.username"
                ></v-text-field>

                <v-btn
                  color="primary"
                  @click.stop="verifyUsername"
                  :loading="isVerifying"
                  >Continue</v-btn
                >
              </v-stepper-content>

              <v-stepper-content step="2">
                <!-- <v-card class="mb-5" color="grey lighten-1" height="200px"></v-card> -->
                <v-alert :value="true" type="success"
                  >We have sent you an email.</v-alert
                >
                <v-text-field
                  label="Enter code"
                  v-model="forgotPasswordModel.code"
                ></v-text-field>
                <v-btn
                  color="primary"
                  @click.stop="verifyCode"
                  :loading="isVerifying"
                  >Continue</v-btn
                >

                <!-- <v-btn flat>Cancel</v-btn> -->
              </v-stepper-content>

              <v-stepper-content step="3">
                <!-- <v-card class="mb-5" color="grey lighten-1" height="200px"></v-card> -->
                <v-text-field
                  :type="showNewPass ? 'text' : 'password'"
                  label="New Password"
                  v-model="forgotPasswordModel.password"
                  :append-icon="showNewPass ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showNewPass = !showNewPass"
                ></v-text-field>
                <v-text-field
                  :type="showNewConPass ? 'text' : 'password'"
                  label="Confirm Password"
                  v-model="forgotPasswordModel.confirmPassword"
                  :append-icon="showNewConPass ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showNewConPass = !showNewConPass"
                ></v-text-field>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click.stop="forgotDialog = false" class="grey--text"
            >Close</v-btn
          >
          <v-btn
            color="success"
            text
            v-if="e1 == 3"
            @click.stop="createNewPassword"
            :loading="isSubmitting"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
const API_ENDPOINT = "/api/users";
const API_ENDPOINT_OTHER = "/api/other";
import { getSubPath, getJwtKeyName } from "../../helpers/utility.js";
import { encyrptText } from "../../helpers/user";

export default {
  data: () => ({
    showPassword: null,
    user: {},
    loading: false,
    databases: [],
    isDatabaseLoading: false,
    logo: null,
    forgotDialog: false,
    e1: 1,
    forgotPasswordModel: {},
    isVerifying: false,
    isSubmitting: false,
    winAuth: false,
    username: null,
    domain: null,
    showNewPass: false,
    showNewConPass: false
  }),
  methods: {
    authenticate() {
      this.loading = true;
      const redirect = this.$route.query.redirect;
      var password = encyrptText(this.user.password);
      this.$axios
        .post(`${API_ENDPOINT}/authenticate`, {
          username: encyrptText(this.user.username),
          dbName: encyrptText(this.user.dbName),
          password
        })
        .then(({ data }) => {
          localStorage.setItem(getJwtKeyName(), JSON.stringify(data));
          // localStorage.setItem("_u_hris", JSON.stringify(data));
          // let host = window.location.origin;
          // let jwtKey = `${host}${process.env.VUE_APP_PATH}:AppUser`;
          // localStorage.setItem(jwtKey, JSON.stringify(data));
          // console.log(redirect);
          // console.log(process.env.VUE_APP_PATH);

          if (typeof redirect == "undefined") {
            //this.$router.push(`${getSubPath()}`);
            window.location.href = `${getSubPath()}`;
          } else {
            //redirect = this.removeSlash(redirect);
            var sliced = redirect.slice(1);
            window.location.href = getSubPath() + `${sliced}`;

            //this.$router.push(getSubPath() + `${sliced}`);
          }
        })
        .catch(err => {
          this.$toast.error(err.response.data.message);
        })
        .finally(() => {
          this.loading = false;
          //this.getAntiforgery();
        });
    },
    getDatabases() {
      this.isDatabaseLoading = true;
      this.$axios
        .get(`${API_ENDPOINT_OTHER}/database`)
        .then(({ data }) => {
          this.databases = data;
          if (data.length > 0) {
            this.user.dbName = data[0].companyCode;
          }
          this.isDatabaseLoading = false;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    removeSlash(redirect) {
      return redirect.replace(/\/$/, "");
    },
    forgotPassword() {
      if (this.user.dbName) {
        this.forgotDialog = true;
      } else {
        this.$toast.error("Please select client.");
      }
    },
    verifyCode() {
      this.isVerifying = true;
      this.forgotPasswordModel.dbName = this.user.dbName;
      this.$axios
        .post(`${API_ENDPOINT}/forgot/check`, {
          code: encyrptText(this.forgotPasswordModel.code),
          username: encyrptText(this.forgotPasswordModel.username),
          DBName: encyrptText(this.forgotPasswordModel.dbName)
        })
        // eslint-disable-next-line no-unused-vars
        .then(({ data }) => {
          //this.toast.show(data);
          this.e1++;
        })
        .catch(({ response }) => {
          this.$toast.success(response.data.message);
        })
        .finally(() => {
          this.isVerifying = false;
        });
    },
    verifyUsername() {
      this.isVerifying = true;
      this.$axios
        .post(`${API_ENDPOINT}/forgot`, {
          Username: encyrptText(this.forgotPasswordModel.username),
          DBName: encyrptText(this.user.dbName)
        })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.e1 = 2;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isVerifying = false;
        });
    },
    createNewPassword() {
      this.isSubmitting = true;
      this.forgotPasswordModel.dbName = this.user.dbName;
      this.$axios
        .post(`${API_ENDPOINT}/forgot/new`, {
          Password: encyrptText(this.forgotPasswordModel.password),
          ConfirmPassword: encyrptText(
            this.forgotPasswordModel.confirmPassword
          ),
          Username: encyrptText(this.forgotPasswordModel.username),
          Email: encyrptText(this.forgotPasswordModel.email),
          Code: encyrptText(this.forgotPasswordModel.code),
          DBName: encyrptText(this.forgotPasswordModel.dbName)
        })
        .then(({ data }) => {
          this.$toast.success(data.message);
          this.e1 = 1;
          this.forgotPasswordModel = {};
          this.forgotDialog = false;
          // setTimeout(() => {

          // }, 2000);
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    getUsername() {
      this.$axios
        .get(`${API_ENDPOINT}/username`)
        .then(({ data }) => {
          this.username = data;
          this.user.username = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getDomain() {
      this.$axios
        .get(`${API_ENDPOINT}/domain`)
        .then(({ data }) => {
          this.domain = data;
        })
        .catch(({ response }) => {
          this.$toast.error(response.data.message);
        });
    },
    getAntiforgery() {
      this.axios.get(`/api/xsrfToken`);
    }
  },
  created() {
    this.getDatabases();
  },
  watch: {
    winAuth(val) {
      if (val) {
        this.getUsername();
        this.getDomain();
      } else {
        this.username = null;
        this.domain = null;
      }
    }
  }
};
</script>
